export default {
  infoLabel: 'Información del Componente',
  closeLabel: 'Cerrar información',
  profilePicture: 'Foto de perfil',
  name: 'Nombre',
  username: 'Nombre de usuario',
  interactions: 'Total',
  comments: 'Comentarios',
  inboxes: 'Bandejas de entrada',
  page: 'Página',
  channel: 'Canal',
  polarity: 'Polaridad',
  posts: 'Publicaciones',
  faq: {
    faq01: {
      title: '¿De dónde vienen los datos de la tabla?',
      description: 'Del área de usuarios más comprometidos de Métricas Propietarias',
    },
    faq02: {
      title: '¿Qué canales es posible utilizar estos datos?',
      description: 'Instagram e Facebook',
    },
    faq03: {
      title: '¿Qué significa la columna Total?',
      description: 'Total es la suma de publicaciones, comentarios e bandejas de entrada',
    },
  },
};
